module.exports = __webpack_public_path__ + "img/default_avatar_female.b70f99a7.png";